module.exports = __webpack_public_path__ + "media/a3.4fd313d5.mp3";